import { PropsWithChildren, useMemo } from 'react';
import { createSafeContext } from '@mews/framework';

interface DocumentsTableContextValue {
    reservationId: string;
    groupId: string;
}

export const { DocumentsTableContextProvider: ContextProvider, useDocumentsTableContext } = createSafeContext<
    'DocumentsTableContext',
    DocumentsTableContextValue
>('DocumentsTableContext');

export const DocumentsTableContextProvider = ({
    children,
    reservationId,
    groupId,
}: PropsWithChildren<DocumentsTableContextValue>) => {
    const contextValue = useMemo(
        () => ({
            reservationId,
            groupId,
        }),
        [reservationId, groupId]
    );

    return <ContextProvider value={contextValue}>{children}</ContextProvider>;
};
